import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EmbeddedAdminMilkPredictionReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/milk-prediction-report', component: FuseLoadable({ loader: () => import('./ViewEmbeddedMilkPredictionReportApp') }) }],
};

export default EmbeddedAdminMilkPredictionReportConfig;
